import React from 'react';

import { useYAxes } from '@mui/x-charts/hooks';

import { AxisId } from 'ff/debrief/models';

interface Props {
    axisId: AxisId;
}

/**
 * Similar to the axis wrapper, there is a bug in MUI X that we need to protect
 * against. When you pass `axisId` to `useYScale` it will try to index the
 * scale object with that id. However, for some reason the object is not
 * populated with the updated list of yAxes IDs on every render. So we need to
 * wait for that object to have a property that matches before we render
 * children.
 * @param props
 * @constructor
 */
const ScrubberWrapper = (props: React.PropsWithChildren<Props>) => {
    const { yAxis } = useYAxes();

    if (yAxis[props.axisId]) {
        return <>{props.children}</>;
    } else {
        return null;
    }
};

export default ScrubberWrapper;
